import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { ScheduleService } from '../schedule/schedule.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { AuthService } from '../auth.service';
import { TimeCardDialogComponent } from '../schedule/schedule/timecard-dialog.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import { HomeService } from '../home/home.service';
import { io } from 'socket.io-client';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MessagerComponent } from '../messager/messager/messager.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { EmployeeService } from '../employee/employee.service';


@Component({
  selector: 'app-timetracking',
  templateUrl: './timetracking.component.html',
  styleUrls: ['./timetracking.component.css'],
  animations: [
    trigger('fadeIn', [
      state('void', style({ opacity: 0 })),
      state('*', style({ opacity: 1 })),
      transition('void => *', [
        animate('0.3s ease-in')
      ]),
    ])
  ]
})
export class TimetrackingComponent implements OnInit {
  socket: any;
  clockedIn: any;
  dateSelected: boolean = false;
  searchTerm: string = '';

  constructor( private employeeService: EmployeeService, private messager: MessagerComponent, private breakpointObserver: BreakpointObserver, public cdr: ChangeDetectorRef, public homeService: HomeService, private _snackbar: MatSnackBar, public scheduleService: ScheduleService, public dialog: MatDialog, private auth: AuthService, ) { }

  private baseURL = environment.baseUrl;
  user;
  usernamee;
  employees;
  updatedEmployees;
  daystatuses;
  selectedDate: Date;
  formattedDate: string;
  employeetype;
  ptoEmployeeId: number;
  showPtoPanel = false;

//tmanagers
tmanagers = {
  "steveg": [], //CSTL
  "nickp": [], //KNX
  "scottp": [], //GRV & COL
  "lisap": [], //CLT
  "rodrigo": [], //RDU & TRI
  "markw": [],
  "all": []
}

  ngOnInit(): void {

    this.socket = io(this.baseURL)
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;



    this.auth.userProfile$.subscribe(
      (profile) => {

        this.user = profile;
        this.usernamee = this.user ? this.user.nickname.charAt(0).toLowerCase() + this.user.nickname.slice(1) : '';

        const metadata = this.user ? this.user['https://rhv2.com.metadata'] : null;
        this.ptoEmployeeId = metadata ? metadata.id : null;
        this.showPtoPanel = !!this.ptoEmployeeId &&
          (this.auth.role === 'TManager' || this.auth.role === 'Admin');

        this.socket.on('clockedInEmit', data => {
          this.clockedIn = data.data;

          this.updatedEmployees = this.employees.map(emp => {
            let match = this.clockedIn.find(item => parseInt(item.technitian) === emp.employeeid);
            if(match) {
               // console.log('MATCHED.');
                return {...emp, street_address: match.street_address, subdivision_name: match.subdivision_name, lot: match.lot};
            } else {
                return emp;
            }
          });
        });

        let loggedInUser;
        if(this.tmanagers.hasOwnProperty(this.usernamee)) {
            loggedInUser = this.usernamee;
        } else {
            loggedInUser = 'all';
        }

        this.scheduleService.getEmployeesByRegion(loggedInUser).subscribe(res => {
          this.employees = res.Data;
          this.homeService.getClockedInFolks().subscribe(
            res => {
              this.clockedIn = res.Data;
              this.updatedEmployees = this.employees.map(emp => {
                let match = this.clockedIn.find(item => parseInt(item.employee_id) === emp.employeeid);
                if(match) {
                    return {...emp, street_address: match.street_address, subdivision_name: match.subdivision_name, lot: match.lot};
                } else {
                    return emp;
                }
              });
              console.log(this.updatedEmployees);
              this.cdr.detectChanges();
            }, err => {
            });
          //find which job they are clocked into:
        });

    });
  }


  get filteredEmployees() {
    if (!this.updatedEmployees) {
      return [];
    }
    const term = (this.searchTerm || '').trim().toLowerCase();
    if (!term) {
      return this.updatedEmployees;
    }
    return this.updatedEmployees.filter(emp =>
      emp.employee_name && emp.employee_name.toLowerCase().includes(term)
    );
  }


  openSnackBar(message: string, action: string) {
    this._snackbar.open(message, action, {
      duration: 2000,
      panelClass: ['custom-snackbar']
    });
  }


  openSchedule(id){
    this.scheduleService.getJobsByRater(id).subscribe(
      res => {
        if(res.Jobs.length === 0){
          this.openSnackBar('No Jobs Scheduled', 'Close');
        }
        else {
          const dialogRef = this.dialog.open(ScheduledJobsDialogComponent, {
            minWidth: '90vw',
            height: '90vh',
            data : {
              jobs: res.Jobs,
            }
          });
        }
      }
    )
  }

  getAvatarUrl(employeeName: string): string {
    // Replace spaces in the employee name with '+' to create the URL-friendly format
    const formattedName = employeeName.replace(' ', '+');
    // Construct the URL with the employee name and return it
    return `https://eu.ui-avatars.com/api/?name=${formattedName}&size=250`;
}

  hasJobs(id: any){
    this.scheduleService.getJobsByRater(id).subscribe(
      res => {
        if(res.Jobs.length === 0){
          return false;
        }else {
          return true;
        }
      },err => {
        return false;
      });
  }

  getTimeZoneDate(ds: string, incldate: boolean): string {
    if (ds) {
      let date = new Date(ds);
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();

      // Add a '0' before the minute if it's less than 10
      let minuteString = (minutes < 10) ? "0" + minutes : minutes.toString();
      let secondString  = (seconds < 10) ? "0" + seconds : seconds.toString();


      let time = hours + ":" + minuteString + ":" + secondString;

      if (incldate) {
        let dateNew = (date.getMonth() + 1) + '-' + date.getDate() + '-' + date.getFullYear();
        return dateNew + ' ' + time;
      } else {
        return time;
      }
    } else {
      return '';
    }
  }

  dateChange(event){
    console.log(event);
    console.log(this.selectedDate);
    if (event.value) {
      this.selectedDate = event.value.toDate(); // Converts Moment to JavaScript Date
      this.formattedDate = moment(this.selectedDate).format('MM/DD/YYYY'); // Formats the date
      console.log(this.formattedDate);
    }

    if (moment().isSame(this.selectedDate, 'day')) {
      this.dateSelected = false;
    } else {
      this.dateSelected = true;
    }

  }

  clearDate(){
    this.messager.openSnackBar('Date reset to today', '', 'successAlert')
    this.selectedDate = null;
    this.dateSelected = false;
  }

  resetToToday(){
    this.dateSelected = false;
  }


  openTimeCardDialog(id){

    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let dialogWidth = '95vw';
    let dialogHeight = '95vh';

    if(!this.dateSelected){
      this.breakpointObserver.observe([
        '(min-width: 540px)'
      ]).subscribe(result => {
        if (result.matches) {
          // If viewport width is at least 540px, use smaller size
          dialogWidth = '55vw';
          dialogHeight = '55vh';
          this.scheduleService.getTodaysTimecard(id, timezone).subscribe(
            res => {
              let jobs = res.Data;
              this.scheduleService.getDayInfo(id, timezone).subscribe(
                res => {
                  const dialogRef = this.dialog.open(TimeCardDialogComponent, {
                    minWidth: dialogWidth,
                    height: dialogHeight,
                    data : {
                      jobs: jobs,
                      day : res.Data,
                      employeetype : this.employeetype,
                      from : 'timetracking',
                      canEditTimes: false
                    }
                  });
                }, err => {
    
                }
              )
            }, err => {
            }
          )
        }else{
          this.scheduleService.getTodaysTimecard(id, timezone).subscribe(
            res => {
              let jobs = res.Data;
              this.scheduleService.getDayInfo(id, timezone).subscribe(
                res => {
                  const dialogRef = this.dialog.open(TimeCardDialogComponent, {
                    minWidth: dialogWidth,
                    height: dialogHeight,
                    data : {
                      jobs: jobs,
                      day : res.Data,
                      employeetype : this.employeetype,
                      canEditTimes: false,
                    }
                  });
                }, err => {
    
                }
              )
            }, err => {
            }
          )
        }});
    }else {
      //get timecard from previous date
        // Subscribe to the BreakpointObserver
        this.breakpointObserver.observe([
          '(min-width: 540px)'
        ]).subscribe(result => {
          if (result.matches) {
            dialogWidth = '55vw';
            dialogHeight = '55vh';
            this.scheduleService.getTimecardByDate(id, this.formattedDate, timezone).subscribe(
              res => {
                let jobs = res.Data;
                console.log(res);
                this.scheduleService.getDayInfoByDate(id, this.formattedDate, timezone).subscribe(
                  res => {
                    console.log(res);
                    const dialogRef = this.dialog.open(TimeCardDialogComponent, {
                      minWidth: 'dialogWidth',
                      height: 'dialogHeight',
                      data : {
                        jobs: jobs,
                        day : res.Data,
                        employeetype : this.employeetype, 
                        from : 'timetracking',
                        canEditTimes: false
                      }
                    });
                  })
              })
          }else{
            this.scheduleService.getTimecardByDate(id, this.formattedDate, timezone).subscribe(
              res => {
                let jobs = res.Data;
                this.scheduleService.getDayInfoByDate(id, this.formattedDate, timezone).subscribe(
                  res => {
                    console.log(res);
                    const dialogRef = this.dialog.open(TimeCardDialogComponent, {
                      minWidth: 'dialogWidth',
                      height: 'dialogHeight',
                      data : {
                        jobs: jobs,
                        day : res.Data,
                        employeetype : this.employeetype,
                        from : 'timetracking',
                        canEditTimes: false
                      }
                    });
                  }
                )
              })
          }
        });
    }
  }


  viewTimecard(id){

    this.employeeService.getOneEmployee(id).subscribe(
      res => {
        this.employeetype = res.employeetype;
        this.openTimeCardDialog(id);
      }
    );
  }


}

@Component({
  template: `
    <h1  mat-dialog-title style="text-align: center;
    font-weight: 500;
    font-size: 30px;
    color: #8bc34a;">Today's Scheduled Jobs</h1>
    <div style="    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;">


        <div *ngFor="let job of this.jobs" id="card" style="border: 1px solid #707070;padding: 30px;min-width: 300px;border-radius: 20px;"
        [ngStyle]="{'background-color': job.firststop ? 'yellow' : '',
                     'color': job.firststop ? 'black' : ''}">


          <p  style="text-align: center; font-weight:200;">{{job.customer_name}}-{{job.customer_jobtype}}</p>
          <div> <p style="text-align: center;">{{job.street_address || '(No Address)'}}</p></div>
          <div> <p style="text-align: center;">{{job.subdivision_name}} - {{job.lot}}</p> </div>
          <div [ngStyle]="job.job_status !== 'Scheduled' ? {'background': 'white', 'color': 'black'} : {}" style="display: flex; align-items: center; justify-content: center;">
            <p style="text-align: center; margin: 0;">{{ job.job_status }}</p><span style="font-size: 12px;margin-left: 5px; " *ngIf="job.firststop == true">**First Stop**</span>
          </div>
        </div>

    </div>

   <div style="display: flex;
    justify-content: center;">
      <button mat-button (click)="dref.close(2)"  style="background: #ffffffaf;
    border: 0;
    height: 40px;
    margin: 30px;
    width: 150px;
    color: #111142;">Close</button>
    </div>
  `
})
export class ScheduledJobsDialogComponent {
  jobs;
  constructor(public dref: MatDialogRef<ScheduledJobsDialogComponent>,  @Inject(MAT_DIALOG_DATA) public data:any){
    this.jobs = this.data.jobs;
  }
}
